/**
 * Identité de la plateforme, affichée dans l'interface, les e-mails et les
 * documents. Modifiable sans toucher au code avec les variables VUE_APP_PLATFORM_*
 * du fichier .env (le serveur a les siennes : PLATFORM_NAME, PLATFORM_TAGLINE,
 * PLATFORM_SIGNATURE).
 */
const env = process.env

export const MARQUE = {
  /** Nom affiché (logo, titres). */
  nom: env.VUE_APP_PLATFORM_NAME || 'Kènèya',
  /** Écriture sans accent : domaine, adresses e-mail, échanges internationaux. */
  nomInternational: env.VUE_APP_PLATFORM_NAME_ASCII || 'Keneya',
  signification: '« la santé » en bambara',
  slogan: env.VUE_APP_PLATFORM_TAGLINE || 'Toute votre clinique, en un seul logiciel',
  signature: env.VUE_APP_PLATFORM_SIGNATURE || 'Conçu par JAMANA DIGITAL',
}
